import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@/core/api/client'

export const languageService = {
	/**
	 * Get all languages
	 */
	getLanguages(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/languages', config)
	},
}

export default languageService
